export class UrlPrefix {
  public static readonly OLD_SETUP_API_PREFIX = 'setup/api/v1/admin';
  public static readonly TOKEN_API_PREFIX_PROD = 'admin/Administration/GenerateAccessToken';
  public static readonly TOKEN_API_PREFIX_DEV = 'oauth2/token';
  public static readonly PRODUCT_INTEGRATION_API_PREFIX = 'api/product/v1/Products'
}
